import React from 'react';
import UserLoginComponent from '../../components/UserLogin/user_login';
import Footer from '../../components/common/Footer'

class LoginPage extends React.Component {
    render() {
        return (
            <div className="dashboard">
                <UserLoginComponent />
                <Footer />
            </div>
        );
    }
}

export default LoginPage;
